import { render } from "./HeaderStats.vue?vue&type=template&id=7b5921e7&scoped=true"
import script from "./HeaderStats.vue?vue&type=script&lang=js"
export * from "./HeaderStats.vue?vue&type=script&lang=js"

import "./HeaderStats.vue?vue&type=style&index=0&id=7b5921e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5921e7"]])

export default __exports__